import { render, staticRenderFns } from "./product-selector.vue?vue&type=template&id=7352f83f"
import script from "./product-selector.vue?vue&type=script&lang=js"
export * from "./product-selector.vue?vue&type=script&lang=js"
import style0 from "./product-selector.vue?vue&type=style&index=0&id=7352f83f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports